// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__18p1C","buttons":"PendingPaymentAlert_buttons__3NN8Z"};